import { __awaiter, __generator } from "tslib";
var prefetchedTasks = new Set();
var isDev = process.env.NODE_ENV === 'development';
function isNamedTask(task) {
    return typeof task === 'object' && 'name' in task && 'load' in task;
}
export function prefetchOnIdle(taskId, tasks, options) {
    var _this = this;
    if (options === void 0) { options = {}; }
    if (prefetchedTasks.has(taskId)) {
        if (isDev) {
            console.log("[prefetch] \u4EFB\u52A1 \"" + taskId + "\" \u5DF2\u6267\u884C\u8FC7\uFF0C\u8DF3\u8FC7");
        }
        return;
    }
    prefetchedTasks.add(taskId);
    var _a = options.timeout, timeout = _a === void 0 ? 2000 : _a, _b = options.sequential, sequential = _b === void 0 ? false : _b;
    if (isDev) {
        console.log("[prefetch] \u5F00\u59CB\u9884\u52A0\u8F7D\u4EFB\u52A1: " + taskId + "\uFF0C\u5171 " + tasks.length + " \u4E2A\u8D44\u6E90");
    }
    var executeTask = function (task, index) { return __awaiter(_this, void 0, Promise, function () {
        var startTime, taskName, loadFn, duration, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    startTime = performance.now();
                    taskName = isNamedTask(task) ? task.name : "\u4EFB\u52A1" + (index + 1);
                    loadFn = isNamedTask(task) ? task.load : task;
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4, loadFn()];
                case 2:
                    _a.sent();
                    if (isDev) {
                        duration = (performance.now() - startTime).toFixed(1);
                        console.log("[prefetch] \u2705 " + taskName + " \u52A0\u8F7D\u6210\u529F (" + duration + "ms)");
                    }
                    return [3, 4];
                case 3:
                    err_1 = _a.sent();
                    if (isDev) {
                        console.warn("[prefetch] \u274C " + taskName + " \u52A0\u8F7D\u5931\u8D25:", err_1);
                    }
                    return [3, 4];
                case 4: return [2];
            }
        });
    }); };
    var executeTasks = function () { return __awaiter(_this, void 0, void 0, function () {
        var startTime, i, totalDuration, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    startTime = performance.now();
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 9, , 10]);
                    if (!sequential) return [3, 6];
                    i = 0;
                    _a.label = 2;
                case 2:
                    if (!(i < tasks.length)) return [3, 5];
                    return [4, executeTask(tasks[i], i)];
                case 3:
                    _a.sent();
                    _a.label = 4;
                case 4:
                    i++;
                    return [3, 2];
                case 5: return [3, 8];
                case 6: return [4, Promise.all(tasks.map(function (task, index) { return executeTask(task, index); }))];
                case 7:
                    _a.sent();
                    _a.label = 8;
                case 8:
                    if (isDev) {
                        totalDuration = (performance.now() - startTime).toFixed(1);
                        console.log("[prefetch] \uD83C\uDF89 \u4EFB\u52A1 \"" + taskId + "\" \u5168\u90E8\u5B8C\u6210\uFF0C\u603B\u8017\u65F6 " + totalDuration + "ms");
                    }
                    return [3, 10];
                case 9:
                    error_1 = _a.sent();
                    console.warn('[prefetch] 预加载失败:', error_1);
                    return [3, 10];
                case 10: return [2];
            }
        });
    }); };
    if ('requestIdleCallback' in window) {
        window.requestIdleCallback(function () { return executeTasks(); }, { timeout: timeout });
    }
    else {
        setTimeout(executeTasks, 100);
    }
}
export function resetPrefetchState(taskId) {
    if (taskId) {
        prefetchedTasks.delete(taskId);
    }
    else {
        prefetchedTasks.clear();
    }
}
export function isPrefetched(taskId) {
    return prefetchedTasks.has(taskId);
}
export function prefetchActions(taskId, actions, options) {
    var _this = this;
    if (options === void 0) { options = {}; }
    if (prefetchedTasks.has(taskId)) {
        if (isDev) {
            console.log("[prefetch] \u4EFB\u52A1 \"" + taskId + "\" \u5DF2\u6267\u884C\u8FC7\uFF0C\u8DF3\u8FC7");
        }
        return;
    }
    prefetchedTasks.add(taskId);
    var _a = options.timeout, timeout = _a === void 0 ? 2000 : _a;
    var execute = function () { return __awaiter(_this, void 0, void 0, function () {
        var startTime, duration;
        var _this = this;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (isDev) {
                        console.log("[prefetch] \u5F00\u59CB\u6267\u884C: " + taskId + "\uFF0C\u5171 " + actions.length + " \u4E2A\u65B9\u6CD5");
                    }
                    startTime = performance.now();
                    return [4, Promise.all(actions.map(function (action, index) { return __awaiter(_this, void 0, void 0, function () {
                            var err_2;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        _a.trys.push([0, 2, , 3]);
                                        return [4, action()];
                                    case 1:
                                        _a.sent();
                                        if (isDev) {
                                            console.log("[prefetch] \u2705 " + taskId + " \u65B9\u6CD5" + (index + 1) + " \u6267\u884C\u6210\u529F");
                                        }
                                        return [3, 3];
                                    case 2:
                                        err_2 = _a.sent();
                                        if (isDev) {
                                            console.warn("[prefetch] \u274C " + taskId + " \u65B9\u6CD5" + (index + 1) + " \u6267\u884C\u5931\u8D25:", err_2);
                                        }
                                        return [3, 3];
                                    case 3: return [2];
                                }
                            });
                        }); }))];
                case 1:
                    _a.sent();
                    if (isDev) {
                        duration = (performance.now() - startTime).toFixed(1);
                        console.log("[prefetch] \uD83C\uDF89 " + taskId + " \u5168\u90E8\u5B8C\u6210\uFF0C\u8017\u65F6 " + duration + "ms");
                    }
                    return [2];
            }
        });
    }); };
    if ('requestIdleCallback' in window) {
        window.requestIdleCallback(function () { return execute(); }, { timeout: timeout });
    }
    else {
        setTimeout(execute, 100);
    }
}
